import classNames from 'classnames';
import React, { ReactNode } from 'react';

import '@eika/input-style';

type BasicLabelProps = React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>;

export interface InputLabelProps extends BasicLabelProps {
    label?: string;
    sublabel?: string;
    infoButton?: React.ReactNode;
    children?: ReactNode;
    className?: string;
}

const InputLabel = ({ label, sublabel, infoButton, children, className, ...rest }: InputLabelProps): JSX.Element => {
    if (label) {
        return (
            <label className={classNames('sgw-input__input-label', className)} {...rest}>
                <span className={classNames('sgw-input__input-mainlabel', { 'with-sublabel': sublabel })}>
                    {label}
                    {infoButton && <span className="sgw-input__info-button-wrapper">{infoButton}</span>}
                </span>
                {sublabel && <span className="sgw-input__input-sublabel">{sublabel}</span>}
                {children}
            </label>
        );
    }

    return <>{children}</>;
};

export default InputLabel;
